import {cn} from '@/utils';
import React from 'react';

interface SectionCardProps {
  children: React.ReactNode;
  className?: string;
}

const SectionCard: React.FC<SectionCardProps> = ({children, className}) => (
  <div className={cn('bg-white rounded-lg p-3', className)}>{children}</div>
);

export default SectionCard;
